import React from 'react'
import {Image as SemanticImage} from 'semantic-ui-react'
import _ from 'lodash'

import DefaultImage from '../../../../assets/category_default_image.png'

class LazyImage extends React.Component {
  constructor(props){
    super(props);
    this.state = {loaded: false}
  }

  handleLoad () {
    this.setState({loaded:true})
  }

  componentDidMount() {
    const {src} = this.props;

    this.img = new Image();
    this.img.onload = this.handleLoad.bind(this);

    this.img.src = src
  }

  renderImage(){
    const {loaded} = this.state;

    if(loaded){
      return <SemanticImage {...this.props} />;
    }

    return <SemanticImage {...this.props} src={DefaultImage} />
  }

  render(){
    return this.renderImage()
  }
}

export default LazyImage;


// WEBPACK FOOTER //
// ./src/components/shared/LazyImage/components/LazyImage.js